import { PageFrame } from '../components/work/page-chrome';
import { PageTitle } from '../components/work/page-states';

export default function Profile() {
  return (
    <PageFrame>
      <PageTitle title="Profile" />
    </PageFrame>
  );
}
